export enum EnumPrivilege {
  CanRead = 0,
  CanCreate = 1,
  CanEdit = 2,
  CanActivate = 3,
  CanDelete = 5,
}
